/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropstatusdrawn2Inputs */

const en_dropstatusdrawn2 = /** @type {(inputs: Dropstatusdrawn2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drawn`)
};

const de_dropstatusdrawn2 = /** @type {(inputs: Dropstatusdrawn2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gezogen`)
};

/**
* | output |
* | --- |
* | "Drawn" |
*
* @param {Dropstatusdrawn2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropstatusdrawn2 = /** @type {((inputs?: Dropstatusdrawn2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropstatusdrawn2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropstatusdrawn2(inputs)
	return de_dropstatusdrawn2(inputs)
});
export { dropstatusdrawn2 as "dropStatusDrawn" }